export default {
	title: 'Autodiagnóstico del Sensor',
	actions: {
		add: 'Añadir',
		edit: 'Editar',
		delete: 'Eliminar',
		batchDelete: 'Eliminación por Lote',
		save: 'Guardar',
		cancel: 'Cancelar',
		confirm: 'Confirmar'
	},
	messages: {
		deleteSuccess: 'Eliminación exitosa',
		actionSuccess: 'Operación exitosa',
		requiredError: 'El campo obligatorio no puede estar vacío'
	},
	buttons: {
		add: 'Añadir',
		batchDelete: 'Eliminación por Lote',
		edit: 'Editar',
		delete: 'Eliminar',
		export: 'Exportar',
		exporting: 'Exportando',
		diagnose: 'Diagnosticar'
	},
	table: {
		projectNo: 'Número de Proyecto',
		deviceName: 'Nombre del Dispositivo',
		pointName: 'Nombre del Punto',
		sensorNo: 'Número del Sensor',
		sensorStatus: 'Estado del Sensor',
		onlineStatus: 'Estado en Línea',
		abnormalCause: 'Causa Anormal',
		lastEigenTime: 'Último Valor Eigen',
		lastWaveTime: 'Última Onda',
		collectionData: 'Últimos Datos de Recolección',
		action: 'Acción'
	},
	form: {
		placeholder: {
			name: 'Nombre del Punto',
			projNo: 'Número de Proyecto',
			pointNo: 'Número del Sensor',
			deviceName: 'Nombre del Dispositivo',
			sensorStatus: 'Estado del Sensor',
			onlineStatus: 'Estado en Línea',
			orgId: 'Organización (Diagnóstico)',
			device: 'Selección de Dispositivo'
		},
		label: {
			project: 'Proyecto',
			pointName: 'Nombre del Punto',
			model: 'Modelo',
			org: 'Organización (Diagnóstico)',
			device: 'Dispositivo',
			direction: 'Dirección de Instalación',
			pointNo: 'Número del Punto',
			sort: 'Ordenar',
			diagnoseGroup: 'Grupo de Modelo de Evaluación de Estado'
		},
		options: {
			normal: 'Normal',
			abnormal: 'Anormal',
			online: 'En Línea',
			offline: 'Fuera de Línea'
		}
	},
	config: {
		gridLayout: 'Diseño de Cuadrícula'
	},
	dialog: {
		add: 'Añadir',
		update: 'Editar'
	}
}
